import React, { useState } from 'react';
import './search.css';

function Search({ onSearch, show }) {
  const [searchKeyword, setSearchKeyword] = useState('');

  const handleSearchChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onSearch(searchKeyword);
  };

  return (
    <>
      <div className={`search-bar ${show ? 'search-bar-show' : ''}`}>
        <form
          onSubmit={handleSearchSubmit}
          className="search-form d-flex align-items-center"
        >
          <input
            type="text"
            name="query"
            value={searchKeyword}
            onChange={handleSearchChange}
            placeholder="Search"
            title="Enter search keyword"
          />
          <button type="submit" title="Search">
            <i className="bi bi-search"></i>
          </button>
        </form>
      </div>
      {/* <div className="search-button">
        <button type="submit" title="Search">
          <i className="bi bi-search"></i>
        </button>
      </div> */}
    </>
  );
}

export default Search;
